import { readHttpErrorStatus } from './httpErrorUtils';

export type MeFailureKind = 'success' | 'hard' | 'transient';

const TRANSIENT_HTTP_STATUSES = new Set([408, 429, 500, 502, 503, 504]);

export const ME_RETRY_BACKOFF_MS = [1000, 2000];

export {
    AUTH_SESSION_PROBE_MS,
    USER_PROFILE_REFRESH_MS,
} from '../config/backgroundSyncConfig';

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export const classifyMeError = (error: any): MeFailureKind => {
    const status = readHttpErrorStatus(error);
    if (status === 401 || status === 403) {
        return 'hard';
    }
    if (status == null) {
        return 'transient';
    }
    if (TRANSIENT_HTTP_STATUSES.has(status)) {
        return 'transient';
    }
    return 'hard';
};

let authRedirectScheduled = false;

/** Full navigation so Redux re-inits; debounced for parallel 401s. */
export const redirectToLoginAfterAuthFailure = () => {
    if (authRedirectScheduled) {
        return;
    }
    authRedirectScheduled = true;
    const path = window.location.pathname;
    if (path === '/login' || path === '/forgot-password') {
        return;
    }
    window.location.assign('/login');
};

export const isAnonymousAuthRequest = (url: string | undefined): boolean => {
    if (!url) {
        return false;
    }
    return url.indexOf('Users/authenticate') !== -1
        || url.indexOf('Users/ResetPassword') !== -1;
};
